import styled from "styled-components";
import { Button } from "styles/elements";
import { FlexColumn } from "styles/layout";
import { Theme } from "theme";

export const PickersContainer = styled(FlexColumn)`
  row-gap: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const SubmitPicksButton = styled(Button)`
  margin: ${Theme.bigPanelPadding};
  margin-top: 30px;
  cursor: pointer;
`;

export const PickemInformationContainer = styled.div`
  padding: ${Theme.bigPanelPadding};
  text-align: center;

  @media (max-width: 700px) {
    padding: ${Theme.smallPanelPadding};
  }
`;

export const DriverPointsInformation = styled.div`
  margin-top: 8px;
`;
